/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function TableMergeCells({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><defs><mask id="TableMergeCells_svg__a" mask-type="alpha" maskUnits="userSpaceOnUse"><path fill="#fff" fillRule="evenodd" d="M0 0h16v16H0zm3.334 2.597h9.868v2.801H3.334zm-.226 8.022h9.865v2.78H3.108zm-.399-4.017h10.666v2.817H2.709z" clipRule="evenodd" /></mask><mask id="TableMergeCells_svg__b" mask-type="alpha" maskUnits="userSpaceOnUse"><path fill="#fff" fillRule="evenodd" d="M0 0h16v16H0zm2.71 6.602h10.665v2.817H2.709z" clipRule="evenodd" /></mask></defs><g mask="url(#TableMergeCells_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M.4 4A2.6 2.6 0 0 1 3 1.4h10A2.6 2.6 0 0 1 15.6 4v8a2.6 2.6 0 0 1-2.6 2.6H3A2.6 2.6 0 0 1 .4 12zM3 2.6h1.4v2.8H1.6V4A1.4 1.4 0 0 1 3 2.6m-1.4 4V12A1.4 1.4 0 0 0 3 13.4h1.4V6.6zm4 0v6.8H13a1.4 1.4 0 0 0 1.4-1.4V6.6zm8.8-1.2V4A1.4 1.4 0 0 0 13 2.6H5.6v2.8z" clipRule="evenodd" /><path stroke="currentColor" strokeWidth={1.2} d="M14.4 10.02H1.594" /></g><path stroke="currentColor" strokeWidth={1.2} d="M8.042 2.597v11.31" mask="url(#TableMergeCells_svg__b)" /></svg>;
}
;